import formatDate from './formatDate'

const displayDateTime = (date: string): string => (date ? formatDate(new Date(date), 'yyyy-MM-dd HH:mm') : '')

export default displayDateTime
